import type { BioBlock, SadguruSlug } from "../content/inspiration";
import { BIOS } from "../content/inspiration";
import { langFromPath } from "../i18n/lang";
import { Page } from "../layout/Page";
import { Section } from "../ui/Section";

/** A stable React key derived from a block's own (unique, verbatim) text. */
function blockKey(block: BioBlock): string {
  return block.kind === "verse" ? block.lines[0] : block.text;
}

function Block({ block }: { block: BioBlock }) {
  if (block.kind === "heading") {
    return (
      <h2 className="font-display mt-8 text-xl text-ink first:mt-0">
        {block.text}
      </h2>
    );
  }
  if (block.kind === "verse") {
    return (
      <blockquote className="mt-6 border-l-2 border-teal-deep/40 pl-5 italic text-ink-soft">
        {block.lines.map((line) => (
          <p key={line}>{line}</p>
        ))}
        {block.attribution ? (
          <footer className="mt-2 text-sm not-italic text-ink-soft/80">
            — {block.attribution}
          </footer>
        ) : null}
      </blockquote>
    );
  }
  return <p className="mt-4 leading-relaxed text-ink-soft">{block.text}</p>;
}

/**
 * One Sadguru's full biography, fetched verbatim from the old site's
 * `/sadguru-*-ji-maharaj` pages and, on `/hi`, their `-HI` twins - both are
 * live on the old site, in full Devanagari prose.
 */
export function SadguruPage({ slug }: { slug: SadguruSlug }) {
  const { lang } = langFromPath(window.location.pathname);
  const bio = BIOS[slug][lang];

  return (
    <Page title={bio.heading} heading={bio.heading}>
      <Section>
        <div className="grid gap-10 md:grid-cols-[minmax(0,320px)_minmax(0,36rem)]">
          <img
            src={bio.portrait.src}
            alt={bio.portrait.alt}
            loading="lazy"
            className="w-full rounded-lg object-cover md:sticky md:top-10 md:self-start"
          />
          <div>
            {bio.body.map((block) => (
              <Block key={blockKey(block)} block={block} />
            ))}
          </div>
        </div>
      </Section>
    </Page>
  );
}
